const VI_TRANSLATE = {
    vietnamese: "Tiếng Việt",
    english: "Tiếng Anh",
    Credit: "Số dư",
    Private: "Cá nhân",
    Group: "Nhóm",
    Login_LoginToYourAccount: 'Đăng nhập',
    Login_EnterEmail: 'Nhập email',
    Login_Password: 'Mật khẩu',
    Login_ForgotPassword: 'Quên mật khẩu?',
    Login_SignIn: 'Đăng nhập',
    Login_NoAccount: 'Chưa có tài khoản?',
    Login_SignUp: 'Đăng ký',
    Login_GetUserProfileError: 'Lỗi lấy thông tin người dùng !!',
    Login_Fail: 'Đăng nhập thất bại',
    AuthApi_NoAccountFound: 'Không tìm thấy tài khoản với địa chỉ email này',
    AuthApi_WrongPassword: 'Sai mật khẩu',
    AuthApi_AccountNotVerified: 'Tài khoản chưa được xác minh',
    AuthApi_ContactAdmin: 'Đã xảy ra lỗi, vui lòng liên hệ Admin',
    Signup_CreateNewAccount: 'Tạo tài khoản mới',
    Signup_FirstName: 'Tên',
    Signup_EnterFirstName: 'Nhập tên',
    Signup_LastName: 'Họ',
    Signup_EnterLastName: 'Nhập họ',
    Signup_EmailAddress: 'Địa chỉ email',
    Signup_EnterEmail: 'Nhập email',
    Signup_Password: 'Mật khẩu',
    Signup_PasswordPlaceholder: 'Mật khẩu',
    Signup_ConfirmPassword: 'Xác nhận mật khẩu',
    Signup_ValidationLength: 'Ít nhất 8 ký tự',
    Signup_ValidationLowercase: 'Ít nhất một chữ cái viết thường (a-z)',
    Signup_ValidationUppercase: 'Ít nhất một chữ cái viết hoa (A-Z)',
    Signup_ValidationNumber: 'Ít nhất một số (0-9)',
    Signup_ValidationSpecialChar: 'Ít nhất một ký tự đặc biệt (!@#...)',
    Signup_DateOfBirth: 'Ngày sinh',
    Signup_DateOfBirthPlaceholder: 'Ngày sinh',
    Signup_Gender: 'Giới tính',
    Signup_Male: 'Nam',
    Signup_Female: 'Nữ',
    Signup_Phone: 'Số điện thoại',
    Signup_EnterPhone: 'Nhập số điện thoại',
    Signup_AgreeMailingList:
        'Tôi đồng ý đăng ký nhận danh sách gửi thư để biết thông tin khóa học trực tuyến',
    Signup_AgreeContact:
        'Tôi đồng ý cho ASPRELY liên hệ với tôi qua điện thoại, email hoặc SMS để giải quyết các thắc mắc/câu hỏi của tôi',
    Signup_AlreadyHaveAccount: 'Đã có tài khoản?',
    Signup_SignIn: 'Đăng nhập',
    Signup_NotifyMissingField: 'Thiếu trường thông tin bắt buộc',
    Signup_NotifyPasswordMismatch: 'Mật khẩu không khớp',
    Signup_NotifyAgreeTerms: 'Bạn phải đồng ý với tất cả các điều khoản và chính sách',
    Signup_NotifyRegisterSuccess: 'Đăng ký thành công',
    Signup_NotifyRegisterError: 'Lỗi đăng ký, vui lòng thử lại',
    Signup_NotifyExistUser: 'Email đã đăng ký',
    ForgotPass_Title: 'Quên mật khẩu',
    ForgotPass_Instruction: 'Mật khẩu sẽ được đặt lại và gửi qua email.',
    ForgotPass_EmailAddress: 'Địa chỉ email',
    ForgotPass_EnterEmail: 'Nhập email',
    ForgotPass_SendButton: 'Gửi cho tôi mật khẩu mới',
    ForgotPass_ForgetIt: '',
    ForgotPass_SendMeBack: 'Quay lại',
    ForgotPass_ToSignInScreen: 'màn hình Đăng nhập.',
    ForgotPass_NotifySuccess: 'Email đã được gửi. Vui lòng kiểm tra email của bạn',
    ForgotPass_NotifyNotFound: 'Không tìm thấy tài khoản nào với địa chỉ email này',
    ForgotPass_NotifyError: 'Đã có lỗi xảy ra, vui lòng liên hệ Quản trị viên',
    Profile_Notify_UploadingAvatar: 'Đang tải ảnh đại diện...',
    Profile_Notify_AvatarUploaded: 'Đã tải lên ảnh đại diện!',
    Profile_Notify_AvatarUploadFailed: 'Tải lên ảnh đại diện thất bại',
    Profile_Notify_CouldNotUpload: 'Không thể tải lên hình ảnh.',
    Profile_Notify_UpdateFailedInvalidRole: 'Cập nhật thất bại: Vai trò người dùng không hợp lệ.',
    Profile_Notify_UpdateSuccess: 'Cập nhật thành công',
    Profile_Notify_UpdateFailed: 'Cập nhật thất bại',
    Profile_Notify_PleaseTryAgain: 'Vui lòng thử lại.',
    Profile_Notify_PasswordChangeSuccess: 'Thay đổi mật khẩu thành công',
    Profile_Notify_InvalidCurrentPassword: 'Mật khẩu hiện tại không hợp lệ',
    Profile_Notify_PasswordChangeError: 'Đã có lỗi xảy ra, vui lòng liên hệ Quản trị viên',
    Profile_Table_Description: 'Mô tả',
    Profile_Table_StartDate: 'Ngày bắt đầu',
    Profile_Table_EndDate: 'Ngày kết thúc',
    Profile_Table_Teacher: 'Giáo viên',
    Profile_Table_Attended: 'Đã tham dự',
    Profile_Table_Remaining: 'Còn lại',
    Profile_Title: 'Trang cá nhân',
    Profile_Breadcrumb_Pages: 'Trang',
    Profile_Tab_Profile: 'Hồ sơ',
    Profile_EditProfile_Title: 'Chỉnh sửa hồ sơ',
    Profile_EditProfile_Avatar: 'Ảnh đại diện',
    Profile_EditProfile_FirstName: 'Tên',
    Profile_EditProfile_LastName: 'Họ',
    Profile_EditProfile_Email: 'Địa chỉ email',
    Profile_EditProfile_Phone: 'Số điện thoại',
    Profile_EditProfile_Gender: 'Giới tính',
    Profile_EditProfile_Male: 'Nam',
    Profile_EditProfile_Female: 'Nữ',
    Profile_EditProfile_Token: 'Số dư',
    Profile_EditProfile_TokenPurchased: 'Đã sử dụng',
    Profile_EditProfile_UpdateBtn: 'Cập nhật hồ sơ',
    Profile_ChangePass_Current: 'Mật khẩu hiện tại',
    Profile_ChangePass_New: 'Mật khẩu',
    Profile_ChangePass_Confirm: 'Xác nhận mật khẩu',
    Profile_ChangePass_Placeholder: 'Mật khẩu',
    Profile_ChangePass_Button: 'Thay đổi mật khẩu',
    Profile_Validation_Length: 'Ít nhất 8 ký tự',
    Profile_Validation_Lowercase: 'Ít nhất một chữ cái viết thường (a-z)',
    Profile_Validation_Uppercase: 'Ít nhất một chữ cái viết hoa (A-Z)',
    Profile_Validation_Number: 'Ít nhất một số (0-9)',
    Profile_Validation_SpecialChar: 'Ít nhất một ký tự đặc biệt (!@#...)',
    Header_LanguageFlag: 'Ngôn ngữ',
    Header_Profile: 'Hồ sơ',
    Header_SignOut: 'Đăng xuất',
    Sidebar_LogoAlt: 'biểu tượng',
    Sidebar_BrandName: 'Aspirely',
    Sidebar_University: 'Trường Đại học',
    Sidebar_Admin: 'Quản trị viên',
    Calendar_Title: 'Lịch học',
    Calendar_BrandName: 'Aspirely',
    Calendar_Credit: 'Credit',
    Course_Student_List_Title: 'Khóa học',
    Course_Student_List_BrandName: 'Aspirely',
    Course_Student_List_Credit: 'Credit',
    Course_Student_List_CourseImageAlt: 'Ảnh khóa học',
    Course_Student_Edit_Title: 'Chi tiết khóa học',
    Course_Student_Edit_BrandName: 'Aspirely',
    Course_Student_Edit_Courses: 'Khóa học',
    Course_Student_Edit_Details: 'Chi tiết',
    Course_Student_Edit_Date: 'Ngày học',
    Course_Student_Edit_Duration: 'Số buổi',
    Course_Student_Edit_Students: 'Học viên',
    Course_Student_Edit_ImageAlt: 'Ảnh khóa học',
    Course_Student_Edit_TeacherAvatarAlt: 'Ảnh giảng viên',
    Course_Student_Edit_EnrollButton: 'Đăng ký khóa học',
    Course_Student_Edit_EnrollSuccess: 'Đăng ký thành công',
    Course_Student_Edit_Syllabus: 'Chương trình học',
    Teacher_Admin_List_Delete_SelectReplacement: 'Chọn giáo viên thay thế',
    Teacher_Admin_List_Delete_AvatarAlt: 'Ảnh đại diện giáo viên',
    Teacher_Admin_List_Delete_Title: 'Bạn có chắc không?',
    Teacher_Admin_List_Delete_Text: 'Bạn sẽ không thể khôi phục giáo viên này!',
    Teacher_Admin_List_Delete_ValidationMessage:
        'Chọn một giáo viên thay thế cho các khoá học của giáo viên này!',
    Teacher_Admin_List_Delete_ConfirmButton: 'Vâng, xoá nó!',
    Teacher_Admin_List_Delete_CancelButton: 'Không, huỷ bỏ!',
    Teacher_Admin_List_Delete_SuccessMessage: 'Xoá thành công!',
    Teacher_Admin_List_Table_Name: 'Tên',
    Teacher_Admin_List_Table_Subject: 'Môn học',
    Teacher_Admin_List_Table_Major: 'Chuyên ngành',
    Teacher_Admin_List_Table_Experience: 'Kinh nghiệm',
    Teacher_Admin_List_Table_OnboardingDate: 'Ngày tham gia',
    Teacher_Admin_List_EditButton: 'Chỉnh sửa',
    Teacher_Admin_List_DeleteButton: 'Xoá',
    Teacher_Admin_List_PageTitle: 'Giáo viên',
    Teacher_Admin_List_Breadcrumb_Brand: 'Aspirely',
    Teacher_Admin_List_Breadcrumb_Active: 'Giáo viên',
    Teacher_Admin_List_CreateButton: 'Tạo mới',
    Teacher_Admin_Edit_Load_Failed_Message: 'Tải thông tin giáo viên thất bại',
    Teacher_Admin_Edit_Load_Failed_Description: 'Không thể tải chi tiết giáo viên.',
    Teacher_Admin_Edit_Avatar_Uploading_Message: 'Đang tải ảnh đại diện...',
    Teacher_Admin_Edit_Avatar_Success_Message: 'Tải ảnh đại diện thành công!',
    Teacher_Admin_Edit_Avatar_Failed_Message: 'Tải ảnh đại diện thất bại',
    Teacher_Admin_Edit_Avatar_Failed_Description: 'Không thể tải lên hình ảnh.',
    Teacher_Admin_Edit_Submit_UpdateSuccess_Message: 'Cập nhật thành công',
    Teacher_Admin_Edit_Submit_CreateSuccess_Message: 'Tạo mới thành công',
    Teacher_Admin_Edit_Submit_UpdateFailed_Message: 'Cập nhật thất bại',
    Teacher_Admin_Edit_Submit_CreateFailed_Message: 'Tạo mới thất bại',
    Teacher_Admin_Edit_Submit_Failed_Description: 'Vui lòng kiểm tra lại thông tin và thử lại.',
    Teacher_Admin_Edit_Validation_MissingFields_Message: 'Thiếu trường thông tin bắt buộc',
    Teacher_Admin_Edit_Validation_MissingFields_Description:
        'Vui lòng điền tất cả các trường bắt buộc có dấu *.',
    Teacher_Admin_Edit_PageTitle_Edit: 'Chỉnh sửa giáo viên',
    Teacher_Admin_Edit_PageTitle_Create: 'Tạo mới giáo viên',
    Teacher_Admin_Edit_Breadcrumb_Brand: 'Aspirely',
    Teacher_Admin_Edit_Breadcrumb_Teachers: 'Giáo viên',
    Teacher_Admin_Edit_Breadcrumb_Active_Edit: 'Chỉnh sửa',
    Teacher_Admin_Edit_Breadcrumb_Active_Create: 'Tạo mới',
    Teacher_Admin_Edit_CardTitle_BasicInfo: 'Thông tin cơ bản',
    Teacher_Admin_Edit_Form_Avatar: 'Ảnh đại diện',
    Teacher_Admin_Edit_Form_FirstName: 'Tên',
    Teacher_Admin_Edit_Form_FirstName_Placeholder: 'Nhập tên',
    Teacher_Admin_Edit_Form_LastName: 'Họ',
    Teacher_Admin_Edit_Form_LastName_Placeholder: 'Nhập họ',
    Teacher_Admin_Edit_Form_Phone: 'Số điện thoại',
    Teacher_Admin_Edit_Form_Phone_Placeholder: 'Nhập số điện thoại',
    Teacher_Admin_Edit_Form_Email: 'Email',
    Teacher_Admin_Edit_Form_Email_Placeholder: 'Nhập địa chỉ email',
    Teacher_Admin_Edit_Form_DOB: 'Ngày sinh',
    Teacher_Admin_Edit_Form_Date_Placeholder: 'Chọn ngày',
    Teacher_Admin_Edit_Form_Gender: 'Giới tính',
    Teacher_Admin_Edit_Form_Gender_Male: 'Nam',
    Teacher_Admin_Edit_Form_Gender_Female: 'Nữ',
    Teacher_Admin_Edit_Form_Subject: 'Môn học',
    Teacher_Admin_Edit_Form_Subject_Placeholder: 'Ví dụ: Toán học',
    Teacher_Admin_Edit_Form_Major: 'Chuyên ngành',
    Teacher_Admin_Edit_Form_Major_Placeholder: 'Ví dụ: Giải tích',
    Teacher_Admin_Edit_Form_Experience: 'Kinh nghiệm',
    Teacher_Admin_Edit_Form_Experience_Placeholder: 'Ví dụ: 5 năm',
    Teacher_Admin_Edit_Form_OnboardingDate: 'Ngày tham gia',
    Teacher_Admin_Edit_Form_Bio: 'Tiểu sử',
    Teacher_Admin_Edit_Form_Bio_Placeholder: 'Nhập tiểu sử giáo viên',
    Teacher_Admin_Edit_CardTitle_AccountInfo: 'Thông tin tài khoản',
    Teacher_Admin_Edit_Form_Password: 'Mật khẩu',
    Teacher_Admin_Edit_Form_Password_Placeholder_Edit: 'Để trống để giữ mật khẩu cũ',
    Teacher_Admin_Edit_Form_Password_Placeholder_Create: 'Nhập mật khẩu',
    Teacher_Admin_Edit_Form_ConfirmPassword: 'Xác nhận mật khẩu',
    Teacher_Admin_Edit_Form_ConfirmPassword_Validation: 'Mật khẩu không khớp',
    Teacher_Admin_Edit_Form_ConfirmPassword_Placeholder: 'Xác nhận mật khẩu',
    Teacher_Admin_Edit_Button_Saving: 'Đang lưu...',
    Teacher_Admin_Edit_Button_Submit: 'Gửi',
    Teacher_Admin_Edit_Button_Cancel: 'Hủy',
    Student_Admin_List_Delete_Title: 'Bạn có chắc không?',
    Student_Admin_List_Delete_Text: 'Bạn sẽ không thể hoàn tác hành động này!',
    Student_Admin_List_Delete_ConfirmButton: 'Vâng, xoá nó!',
    Student_Admin_List_Delete_SuccessTitle: 'Đã xoá!',
    Student_Admin_List_Delete_SuccessText: 'Học sinh đã được xoá.',
    Student_Admin_List_Table_Name: 'Tên',
    Student_Admin_List_Table_Email: 'Email',
    Student_Admin_List_Table_Phone: 'Số điện thoại',
    Student_Admin_List_Table_DOB: 'Ngày sinh',
    Student_Admin_List_Table_Gender: 'Giới tính',
    Student_Admin_List_Table_Status: 'Trạng thái',
    Student_Admin_List_Button_Edit: 'Chỉnh sửa',
    Student_Admin_List_Button_Delete: 'Xoá',
    Student_Admin_List_PageTitle: 'Học sinh',
    Student_Admin_List_Breadcrumb_Brand: 'Aspirely',
    Student_Admin_List_Breadcrumb_Active: 'Học sinh',
    Student_Admin_List_Filter_Name_Placeholder: 'Tên',
    Student_Admin_List_Filter_Email_Placeholder: 'Email',
    Student_Admin_List_Filter_Status_Placeholder: 'Chọn trạng thái',
    Student_Admin_List_Filter_Status_NotTested: 'Chưa kiểm tra',
    Student_Admin_List_Filter_Status_Tested: 'Đã kiểm tra',
    Student_Admin_List_Filter_Status_Studying: 'Đang học',
    Student_Admin_List_Filter_Status_Completed: 'Đã hoàn thành',
    Student_Admin_List_Filter_Status_Inactive: 'Không hoạt động',
    Student_Admin_List_Filter_Button_Search: 'Tìm kiếm',
    Student_Admin_List_Button_Create: 'Tạo mới',
    Student_Admin_Edit_Submit_UpdateSuccess: 'Cập nhật thành công',
    Student_Admin_Edit_Submit_CreateSuccess: 'Tạo mới thành công',
    Student_Admin_Edit_Validation_GeneralError:
        'Vui lòng điền tất cả các trường bắt buộc trước khi gửi.',
    Student_Admin_Edit_Validation_AvatarError: 'Vui lòng tải lên ảnh đại diện.',
    Student_Admin_Edit_Validation_MissingFieldsTitle: 'Thiếu trường thông tin bắt buộc',
    Student_Admin_Edit_Avatar_Uploading: 'Đang tải ảnh đại diện...',
    Student_Admin_Edit_Avatar_Success: 'Tải ảnh đại diện thành công!',
    Student_Admin_Edit_Avatar_FailedTitle: 'Tải ảnh đại diện thất bại',
    Student_Admin_Edit_Avatar_FailedDescription: 'Không thể tải lên hình ảnh.',
    Student_Admin_Edit_BasicInfo_Title: 'Thông tin cơ bản',
    Student_Admin_Edit_Form_FirstName: 'Tên',
    Student_Admin_Edit_Validation_FirstNameRequired: 'Tên là bắt buộc',
    Student_Admin_Edit_Form_FirstNamePlaceholder: 'Nhập tên',
    Student_Admin_Edit_Form_LastName: 'Họ',
    Student_Admin_Edit_Validation_LastNameRequired: 'Họ là bắt buộc',
    Student_Admin_Edit_Form_LastNamePlaceholder: 'Nhập họ',
    Student_Admin_Edit_Form_Gender: 'Giới tính',
    Student_Admin_Edit_Form_GenderMale: 'Nam',
    Student_Admin_Edit_Form_GenderFemale: 'Nữ',
    Student_Admin_Edit_Form_Email: 'Email',
    Student_Admin_Edit_Validation_EmailRequired: 'Email là bắt buộc',
    Student_Admin_Edit_Validation_EmailInvalid: 'Địa chỉ email không hợp lệ',
    Student_Admin_Edit_Form_DOB: 'Ngày sinh',
    Student_Admin_Edit_Validation_DOBRequired: 'Ngày sinh là bắt buộc',
    Student_Admin_Edit_Form_DOBPlaceholder: 'MM/DD/YYYY',
    Student_Admin_Edit_Form_Phone: 'Số điện thoại',
    Student_Admin_Edit_Validation_PhoneRequired: 'Số điện thoại là bắt buộc',
    Student_Admin_Edit_Form_Status: 'Trạng thái',
    Student_Admin_Edit_Status_NotTested: 'Chưa kiểm tra',
    Student_Admin_Edit_Status_Tested: 'Đã kiểm tra',
    Student_Admin_Edit_Status_Studying: 'Đang học',
    Student_Admin_Edit_Status_Completed: 'Đã hoàn thành',
    Student_Admin_Edit_Status_Inactive: 'Không hoạt động',
    Student_Admin_Edit_Form_TestType: 'Loại bài kiểm tra',
    Student_Admin_Edit_Form_Feedback: 'Nhận xét',
    Student_Admin_Edit_Form_FeedbackPlaceholder: 'Nhập nhận xét về bài test của học sinh',
    Student_Admin_Edit_AccountInfo_Title: 'Thông tin tài khoản',
    Student_Admin_Edit_Form_UserName: 'Tên người dùng',
    Student_Admin_Edit_Form_Password: 'Mật khẩu',
    Student_Admin_Edit_Validation_PasswordRequired: 'Mật khẩu là bắt buộc',
    Student_Admin_Edit_Form_ConfirmPassword: 'Xác nhận mật khẩu',
    Student_Admin_Edit_Token_Title: 'Số dư',
    Student_Admin_Edit_Token_Table_Type: 'Loại số dư',
    Student_Admin_Edit_Token_Table_Amount: 'Số lượng',
    Student_Admin_Edit_TokenPurchased_Title: 'Đã sử dụng',
    Student_Admin_Edit_TokenPurchased_Table_Type: 'Loại số dư',
    Student_Admin_Edit_TokenPurchased_Table_Amount: 'Số lượng',
    Student_Admin_Edit_TokenTopUp_Type: 'Loại số dư',
    Student_Admin_Edit_TokenTopUp_TypePlaceholder: 'Chọn loại...',
    Student_Admin_Edit_TokenTopUp_Quantity: 'Số lượng',
    Student_Admin_Edit_TokenTopUp_Validation_Type: 'Vui lòng chọn loại số dư.',
    Student_Admin_Edit_TokenTopUp_Validation_AmountTitle: 'Số lượng không hợp lệ',
    Student_Admin_Edit_TokenTopUp_Validation_AmountDescription: 'Số lượng phải lớn hơn 0.',
    Student_Admin_Edit_TokenTopUp_Success: 'Nạp số dư thành công',
    Student_Admin_Edit_TokenTopUp_Failed: 'Đã xảy ra lỗi, vui lòng thử lại',
    Student_Admin_Edit_TokenTopUp_Button: 'Nạp',
    Student_Admin_Edit_Button_Submit: 'Gửi',
    Student_Admin_Edit_Button_Cancel: 'Hủy',
    Course_Admin_List_Delete_Title: 'Bạn có chắc không?',
    Course_Admin_List_Delete_Text: 'Bạn sẽ không thể khôi phục khóa học này!',
    Course_Admin_List_Delete_ConfirmButton: 'Vâng, xoá nó!',
    Course_Admin_List_Delete_CancelButton: 'Không, huỷ bỏ!',
    Course_Admin_List_Delete_SuccessMessage: 'Xoá thành công!',
    Course_Admin_List_Table_Title: 'Tiêu đề',
    Course_Admin_List_Table_Description: 'Mô tả',
    Course_Admin_List_Table_StartDate: 'Ngày bắt đầu',
    Course_Admin_List_Table_EndDate: 'Ngày kết thúc',
    Course_Admin_List_Table_Action: 'Hành động',
    Course_Admin_List_Button_Edit: 'Chỉnh sửa',
    Course_Admin_List_Button_Delete: 'Xoá',
    Course_Admin_List_PageTitle: 'Các khoá học',
    Course_Admin_List_Breadcrumb_Brand: 'Aspirely',
    Course_Admin_List_Breadcrumb_Active: 'Các khoá học',
    Course_Admin_List_Button_Create: 'Tạo mới',
    Course_Admin_Edit_Upload_FileError: 'Bạn chỉ có thể tải lên tệp JPG/PNG!',
    Course_Admin_Edit_Upload_SizeError: 'Hình ảnh phải nhỏ hơn 2MB!',
    Course_Admin_Edit_Lesson_LoadFailed_Title: 'Tải danh sách bài học thất bại',
    Course_Admin_Edit_Lesson_LoadFailed_Description: 'Không thể tải danh sách bài học.',
    Course_Admin_Edit_TokenType_LoadFailed_Title: 'Tải loại số dư thất bại',
    Course_Admin_Edit_TokenType_LoadFailed_Description: 'Không thể tải các loại số dư.',
    Course_Admin_Edit_Detail_LoadFailed_Title: 'Tải chi tiết khóa học thất bại',
    Course_Admin_Edit_Detail_LoadFailed_Description: 'Không thể tải chi tiết khóa học.',
    Course_Admin_Edit_Validation_SelectTeacher: 'Vui lòng chọn một giáo viên.',
    Course_Admin_Edit_Validation_SelectProgram: 'Vui lòng chọn một chương trình học.',
    Course_Admin_Edit_Submit_UpdateSuccess: 'Cập nhật thành công',
    Course_Admin_Edit_Submit_CreateSuccess: 'Tạo mới thành công',
    Course_Admin_Edit_Submit_UpdateFailed: 'Cập nhật thất bại',
    Course_Admin_Edit_Submit_CreateFailed: 'Tạo mới thất bại',
    Course_Admin_Edit_Submit_FailedDescription: 'Vui lòng kiểm tra lại thông tin và thử lại.',
    Course_Admin_Edit_Validation_MissingFields_Title: 'Thiếu trường thông tin bắt buộc',
    Course_Admin_Edit_Validation_MissingFields_Description:
        'Vui lòng điền tất cả các trường bắt buộc có dấu *.',
    Course_Admin_Edit_Thumbnail_Uploading: 'Đang tải ảnh bìa...',
    Course_Admin_Edit_Thumbnail_UploadSuccess: 'Tải ảnh bìa thành công!',
    Course_Admin_Edit_Thumbnail_UploadFailed_Title: 'Tải ảnh bìa thất bại',
    Course_Admin_Edit_Thumbnail_UploadFailed_Description: 'Không thể tải lên ảnh bìa.',
    Course_Admin_Edit_Lesson_Delete_Title: 'Bạn có chắc không?',
    Course_Admin_Edit_Lesson_Delete_Text: 'Bạn sẽ không thể khôi phục bài học này!',
    Course_Admin_Edit_Lesson_Delete_ConfirmButton: 'Vâng, xoá nó!',
    Course_Admin_Edit_Lesson_Delete_CancelButton: 'Không, huỷ bỏ!',
    Course_Admin_Edit_Lesson_Delete_SuccessMessage: 'Xoá thành công!',
    Course_Admin_Edit_Lesson_Delete_Failed_Title: 'Xoá thất bại',
    Course_Admin_Edit_Lesson_Delete_Failed_Description: 'Không thể xoá bài học.',
    Course_Admin_Edit_Lesson_Table_Description: 'Mô tả',
    Course_Admin_Edit_Lesson_Table_StartDate: 'Ngày bắt đầu',
    Course_Admin_Edit_Lesson_Table_EndDate: 'Ngày kết thúc',
    Course_Admin_Edit_Lesson_Table_Action: 'Hành động',
    Course_Admin_Edit_Lesson_Table_EditButton: 'Chỉnh sửa',
    Course_Admin_Edit_Lesson_Table_DeleteButton: 'Xoá',
    Course_Admin_Edit_Enrollment_Unenroll_Title: 'Hủy ghi danh học sinh',
    Course_Admin_Edit_Enrollment_Unenroll_Refund_Content:
        'Bạn có muốn hoàn lại số dư cho học sinh này không?',
    Course_Admin_Edit_Enrollment_Unenroll_Refund_Ok: 'Có, Hoàn số dư',
    Course_Admin_Edit_Enrollment_Unenroll_Refund_Cancel: 'Không, Chỉ hủy ghi danh',
    Course_Admin_Edit_Enrollment_Table_FirstName: 'Tên',
    Course_Admin_Edit_Enrollment_Table_LastName: 'Họ',
    Course_Admin_Edit_Enrollment_Table_Email: 'Email',
    Course_Admin_Edit_Enrollment_Table_Status: 'Trạng thái',
    Course_Admin_Edit_Enrollment_Table_Action: 'Hành động',
    Course_Admin_Edit_Enrollment_Unenroll_Description:
        'Bạn có chắc chắn muốn hủy ghi danh học sinh này không?',
    Course_Admin_Edit_Enrollment_Unenroll_Confirm: 'Có',
    Course_Admin_Edit_Enrollment_Unenroll_Cancel: 'Không',
    Course_Admin_Edit_Enrollment_Table_DeleteButton: 'Xoá',
    Course_Admin_Edit_Enrollment_Title: 'Học sinh đã ghi danh',
    Course_Admin_Edit_PageTitle_Edit: 'Chỉnh sửa khóa học',
    Course_Admin_Edit_PageTitle_Create: 'Tạo mới khóa học',
    Course_Admin_Edit_Breadcrumb_Brand: 'Aspirely',
    Course_Admin_Edit_Breadcrumb_Courses: 'Các khoá học',
    Course_Admin_Edit_Breadcrumb_Active_Edit: 'Chi tiết',
    Course_Admin_Edit_Breadcrumb_Active_Create: 'Tạo mới',
    Course_Admin_Edit_CardTitle_BasicInfo: 'Thông tin cơ bản',
    Course_Admin_Edit_Thumbnail_Alt: 'ảnh bìa',
    Course_Admin_Edit_Form_Title: 'Tiêu đề',
    Course_Admin_Edit_Form_Title_Placeholder: 'Nhập tiêu đề khóa học',
    Course_Admin_Edit_Form_StartDate: 'Ngày bắt đầu',
    Course_Admin_Edit_Form_StartDate_Placeholder: 'Chọn ngày bắt đầu',
    Course_Admin_Edit_Form_EndDate: 'Ngày kết thúc',
    Course_Admin_Edit_Form_EndDate_Placeholder: 'Chọn ngày kết thúc',
    Course_Admin_Edit_Form_TotalSlot: 'Tổng số chỗ',
    Course_Admin_Edit_Form_TotalSlot_Placeholder: 'Ví dụ: 10',
    Course_Admin_Edit_Form_TokenCost: 'Giá (Số dư)',
    Course_Admin_Edit_Form_TokenCost_Placeholder: 'Ví dụ: 5',
    Course_Admin_Edit_Form_TotalLessons: 'Tổng số bài học',
    Course_Admin_Edit_Form_TotalLessons_Placeholder: 'Ví dụ: 8',
    Course_Admin_Edit_Form_TokenType: 'Loại số dư',
    Course_Admin_Edit_Form_TokenType_Loading: 'Đang tải...',
    Course_Admin_Edit_Form_TokenType_Select: 'Chọn loại',
    Course_Admin_Edit_Form_Teacher: 'Giáo viên',
    Course_Admin_Edit_Form_Teacher_Select: 'Nhấn để chọn',
    Course_Admin_Edit_Form_Teacher_Placeholder: 'Chọn một giáo viên',
    Course_Admin_Edit_Form_Program: 'Chương trình học',
    Course_Admin_Edit_Form_Program_Select: 'Nhấn để chọn',
    Course_Admin_Edit_Form_Program_Placeholder: 'Chọn một chương trình học',
    Course_Admin_Edit_Form_Description: 'Mô tả',
    Course_Admin_Edit_Form_Description_Placeholder: 'Nhập mô tả khóa học (tùy chọn)',
    Course_Admin_Edit_Button_Saving: 'Đang lưu...',
    Course_Admin_Edit_Button_Submit: 'Gửi',
    Course_Admin_Edit_Button_Cancel: 'Hủy',
    Course_Admin_Edit_Lesson_Title: 'Các bài học',
    Course_Admin_Edit_Lesson_AddButton: 'Thêm bài học',
    Course_Admin_Edit_Lesson_AddButton_Noti: 'Hãy chọn giảng viên trước khi tạo lịch học',
    Course_Admin_Edit_Pagination: '{{start}}-{{end}} của {{total}} mục',
    Program_Admin_List_Delete_Title: 'Bạn có chắc không?',
    Program_Admin_List_Delete_Text: 'Bạn sẽ không thể khôi phục chương trình học này!',
    Program_Admin_List_Delete_ConfirmButton: 'Vâng, xoá nó!',
    Program_Admin_List_Delete_CancelButton: 'Không, huỷ bỏ!',
    Program_Admin_List_Delete_SuccessMessage: 'Xoá thành công!',
    Program_Admin_List_Table_Name: 'Tên',
    Program_Admin_List_Table_Description: 'Mô tả',
    Program_Admin_List_Table_Action: 'Hành động',
    Program_Admin_List_Button_Edit: 'Chỉnh sửa',
    Program_Admin_List_Button_Delete: 'Xoá',
    Program_Admin_List_PageTitle: 'Chương trình học',
    Program_Admin_List_Breadcrumb_Brand: 'Aspirely',
    Program_Admin_List_Breadcrumb_Active: 'Chương trình học',
    Program_Admin_List_Button_Create: 'Tạo mới',
    Program_Admin_Edit_Load_Failed_Message: 'Tải chi tiết chương trình học thất bại',
    Program_Admin_Edit_Load_Failed_Description: 'Không thể tải chi tiết chương trình học.',
    Program_Admin_Edit_Validation_MissingFields_Message: 'Thiếu trường thông tin bắt buộc',
    Program_Admin_Edit_Validation_MissingFields_Description:
        'Vui lòng điền tất cả các trường bắt buộc có dấu *.',
    Program_Admin_Edit_Submit_UpdateSuccess_Message: 'Cập nhật thành công',
    Program_Admin_Edit_Submit_CreateSuccess_Message: 'Tạo mới thành công',
    Program_Admin_Edit_Submit_UpdateFailed_Message: 'Cập nhật thất bại',
    Program_Admin_Edit_Submit_CreateFailed_Message: 'Tạo mới thất bại',
    Program_Admin_Edit_Submit_Failed_Description: 'Vui lòng thử lại.',
    Program_Admin_Edit_PageTitle_Edit: 'Chỉnh sửa chương trình học',
    Program_Admin_Edit_PageTitle_Create: 'Tạo mới chương trình học',
    Program_Admin_Edit_Breadcrumb_Brand: 'Aspirely',
    Program_Admin_Edit_Breadcrumb_Programs: 'Chương trình học',
    Program_Admin_Edit_Breadcrumb_Active_Edit: 'Chi tiết',
    Program_Admin_Edit_Breadcrumb_Active_Create: 'Tạo mới',
    Program_Admin_Edit_CardTitle_BasicInfo: 'Thông tin cơ bản',
    Program_Admin_Edit_Form_Name: 'Tên',
    Program_Admin_Edit_Form_Name_Placeholder: 'Nhập tên chương trình học',
    Program_Admin_Edit_Form_Description: 'Mô tả',
    Program_Admin_Edit_Form_Description_Placeholder: 'Nhập mô tả chương trình học',
    Program_Admin_Edit_Button_Saving: 'Đang lưu...',
    Program_Admin_Edit_Button_Submit: 'Gửi',
    Program_Admin_Edit_Button_Cancel: 'Hủy',
    LessonModal_Admin_Fetch_Failed_Title: 'Tải thất bại',
    LessonModal_Admin_Fetch_Failed_Description: 'Không thể tải chi tiết bài học. Vui lòng thử lại.',
    LessonModal_Admin_Validation_MissingFields_Title: 'Thiếu trường thông tin bắt buộc',
    LessonModal_Admin_Validation_MissingFields_Description:
        'Vui lòng điền tất cả các trường bắt buộc có dấu *.',
    LessonModal_Admin_Submit_UpdateSuccess: 'Cập nhật thành công',
    LessonModal_Admin_Submit_UpdateFailed_Title: 'Cập nhật thất bại',
    LessonModal_Admin_Submit_Failed_Description: 'Vui lòng thử lại.',
    LessonModal_Admin_Submit_CreateSuccess: 'Tạo mới thành công',
    LessonModal_Admin_Submit_CreateFailed_Title: 'Tạo mới thất bại',
    LessonModal_Admin_Submit_Failed_Description_Create:
        'Vui lòng kiểm tra lại thông tin và thử lại.',
    LessonModal_Admin_Title_Edit: 'Chỉnh sửa bài học',
    LessonModal_Admin_Title_Create: 'Tạo mới bài học',
    LessonModal_Admin_Button_Cancel: 'Hủy',
    LessonModal_Admin_Button_Ok: 'Đồng ý',
    LessonModal_Admin_Form_Description: 'Mô tả',
    LessonModal_Admin_Form_StartDate: 'Ngày bắt đầu',
    LessonModal_Admin_Form_StartDate_Placeholder: 'Chọn ngày bắt đầu',
    LessonModal_Admin_Form_EndDate: 'Ngày kết thúc',
    LessonModal_Admin_Form_EndDate_Placeholder: 'Chọn ngày kết thúc',
    LessonModal_Admin_Form_Link: 'Đường dẫn buổi học',
    LessonModal_Admin_Form_Link_Placeholder: 'Nhập đường dẫn (ví dụ: Zoom, Google Meet)',
    LessonModal_Student_Upload_Success_Title: 'Tải video lên thành công!',
    LessonModal_Student_Upload_Failed_Title: 'Tải video lên thất bại',
    LessonModal_Student_Upload_Failed_Description: 'Không thể tải lên video.',
    LessonModal_Student_Update_Success_Title: 'Cập nhật thành công',
    LessonModal_Student_Update_Failed_Title: 'Cập nhật thất bại',
    LessonModal_Student_Update_Failed_Description: 'Vui lòng thử lại.',
    LessonModal_Student_Button_Cancel: 'Hủy',
    LessonModal_Student_Button_Ok: 'Đồng ý',
    LessonModal_Student_Button_Upload: 'Tải lên',
    LessonModal_Student_Enroll_Prompt: 'Hãy đăng ký tham gia để có thể xem nội dung bài giảng nhé!',
    LessonModal_Student_NoRecord_Prompt: 'Chưa có bản ghi, vui lòng quay lại sau!',
    ProgramModal_Title: 'Chọn chương trình học',
    ProgramModal_Button_Ok: 'Đồng ý',
    ProgramModal_Button_Cancel: 'Hủy',
    TeacherModal_Title: 'Chọn giáo viên',
    TeacherModal_Button_Ok: 'Đồng ý',
    TeacherModal_Button_Cancel: 'Hủy',
    TeacherModal_Avatar_Alt: 'Ảnh đại diện giáo viên',
    Menu_Dashboard: 'Bảng điều khiển',
    Menu_Teachers: 'Giảng viên',
    Menu_Students: 'Học viên',
    Menu_Courses: 'Khóa học',
    Menu_Programs: 'Chương trình',
    Dashboard_Event_Modal_Title: 'Chi tiết sự kiện',
    Dashboard_Event_Modal_Button_Close: 'Đóng',
    Dashboard_Event_Modal_Button_Join: 'Tham gia buổi học',
    Dashboard_Event_Modal_Label_Course: 'Khóa học',
    Dashboard_Event_Modal_Label_Description: 'Mô tả',
    Dashboard_Event_Modal_Label_Start: 'Bắt đầu',
    Dashboard_Event_Modal_Label_End: 'Kết thúc',
    Dashboard_Event_Modal_Label_Duration: 'Thời lượng',
    Dashboard_Event_Modal_Label_Minutes: 'phút',
    Course_Admin_Edit_Lesson_Unenroll_Success_Description: 'Đã xóa học sinh khỏi lớp học',
    Course_Admin_Edit_Lesson_Unenroll_Error_Description:
        'Xóa học sinh khỏi lớp học thất bại, thử lại sau'
};

export default VI_TRANSLATE;
